module.exports = __webpack_public_path__ + "static/media/check.dfc9c030.svg";